/* eslint-disable security/detect-unsafe-regex */
export const MultilineRenderer = ({
  text,
  styles,
}: {
  text: string | null | undefined;
  styles: {
    paragraph?: string;
  };
}) => {
  if (!text) {
    return <></>;
  }

  const paragraphs = text.trim().split(/(?:\r?\n){2,}/);

  return (
    <>
      {paragraphs.map((paragraph, i) => (
        <p className={styles?.paragraph} key={i}>
          {paragraph.split(/\r?\n/).map((line, j, arr) => (
            <span key={j}>
              {line}
              {j < arr.length - 1 && <br />}
            </span>
          ))}
        </p>
      ))}
    </>
  );
};
